import type { AnyRoute } from "@tanstack/react-router";

import { createAuditLogRoutes } from "./createAuditLogRoutes";
import type { AuditRouteDeps } from "./auditRouteContext";

export type { AuditRouteDeps, AuditRouteFactory } from "./auditRouteContext";

export function createAuditRoutes(deps: AuditRouteDeps): AnyRoute[] {
  return [...createAuditLogRoutes(deps)];
}
